/* eslint-disable */
// Header of the page/web app
import React, { useState, useEffect } from "react";
import { useNavigate,useSearchParams } from "react-router-dom";
import { Button, Box, Tooltip, Typography, Paper } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import axios, { getVersionInfo } from "../../api";

import Stack from '@mui/material/Stack';
import clogo from "../../assets/Logo.png"

const Header = (props) => {
  const navigate = useNavigate();
  const [versionInfo, setVersionInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  // Load version information on component mount
  useEffect(() => {
    const loadVersionInfo = async () => {
      try {
        console.log("getVersionInfo");
        
        setLoading(true);
        const response = await getVersionInfo();
        console.log("Response: ", response);
        
        if (response?.data?.Status === "success") {
          setVersionInfo(response?.data?.Data);
        }
      } catch (error) {
        console.error("Failed to load version info:", error);
      } finally {
        setLoading(false);
      }
    };

    loadVersionInfo();
  }, []);

  const LogOut = () => {
    let url = "/logout"
    axios.post(url)
      .then(data => {
         axios.post("/invoicebrowse", {   prsMd: "D",sRawtSeqNo:Number(localStorage.getItem("nRawtSeqN"))} /*axiosConfig*/)
        .then((res) => {
       const usertype = localStorage.getItem("type")
       let baseUrl = window.location.pathname.split('/eserv/')[0] || '';
       baseUrl = baseUrl + '/eserv';
        // window.location.href = baseUrl +"/login?type=" + usertype;
        navigate(`/login?type=${usertype}`) 
        localStorage.removeItem('token');
        localStorage.removeItem('detail');
          if(res.data.output.rtnSts===2){
            setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
          }
        })

       



      })
      
      
      .catch(e => {
        console.log(e)
        // setLoading(false)
        // setPopupMessage({ state: true, type: "error", message: "Something went wrong please try again." })
      }
      )


  }

  // Custom tooltip content for version information
  const VersionTooltip = () => {
    if (!versionInfo) {
      return <Typography>Loading version information...</Typography>;
    }

    return (
      <div style={{
        backgroundColor: 'transparent',
        color: 'white',
        padding: '12px 16px',
        borderRadius: '8px',
        fontSize: '13px',
        fontFamily: 'Arial, sans-serif',
        lineHeight: '1.4',
        position: 'relative',
        minWidth: '180px',
        maxWidth: '250px',
        border: 'none'
      }}>
        <div style={{ marginBottom: '4px' }}>
          Version : {versionInfo?.version}
        </div>
        <div>
          Build Date: : {versionInfo?.buildDate}
        </div>
      </div>
    );
  };

  return (
    <>
      <Stack
        className="ixMainHeaderLayout"
        direction="row"
        spacing={1}

        justifyContent="space-between"
      >
        {
          <Box />
        }



        <img style={{ height: "2.5em" }} src={clogo} alt="logo" />

        <Stack alignItems={"center"} spacing={1} direction={"row"}>


          <div > {localStorage.getItem("name")} </div>


          <Tooltip 
            title={<VersionTooltip />} 
            placement="left"
            componentsProps={{
              tooltip: {
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    padding: 0
                  }
                }
              }
            }}
          >
            <Button styletype="icon"><InfoOutlinedIcon /></Button>
          </Tooltip>
          <Button onClick={() => { LogOut() }} styletype="danger"><LogoutIcon /></Button>




        </Stack>
      </Stack>
    </>
  );
};

export default Header;